import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
declare var bootbox:any;
declare var $:any;
@Component({
  selector: 'undefined-survey-distribution-queue',
  template: require('./survey-distribution-queue.component.html')
})
export class SurveyDistributionQueueComponent extends BaseComponent implements OnInit {

  
  public modalBusy: Subscription;

  public queuedSurveys = [];

  public selectedOrganizationId = -1;
  public selectedManagerId = -1;

  public organisations = [];
  public managers = [];

  public selectedQueueSurveys = [];

  public updateSelectedQueueEmailsFromEmails() {
    if(this.selectedQueueSurveys == null || this.selectedQueueSurveys.length <= 0)
      return;
    var found = false;
    for(var i=0;i<this.queuedSurveys.length;i++) {
      var surveys = this.queuedSurveys[i];
      for(var k=0;k<surveys.length;k++) {
        var survey = surveys[k];
        if(survey.tipsEmailQueueId == this.selectedQueueSurveys[0].tipsEmailQueueId) {
          this.selectedQueueSurveys = surveys;
          found = true;
          break;
        }
      }
      if(found)
        break;
    }
  }

  public getDepartment(mgr) {
    if(mgr.department!=null)
      return " (" + mgr.department.name + " - " + mgr.email + ")";
    else
      return "";
  }

  public loadQueuedSurveys() {
    this.modalBusy = this.busy = this.lsApi.getQueuedSurveysForListing(this.selectedOrganizationId, this.selectedManagerId).subscribe(resp => {
        if(resp.status) {
            this.queuedSurveys = resp.data;
            this.updateSelectedQueueEmailsFromEmails();
        }
    },
    error => {
        console.log(error);
    });
  }

  public organizationSelectionChanged() {
    this.selectedManagerId = -1;
    this.loadOrganizationManagers();
  }

  public getQueuedCount(survey) {
    if(survey.manager==null) return "N/A";
    return survey.manager.subordinateCount;
  }

  public getLastSentOn(survey) {
    if(survey.distributedOn==null) {
      return null;
    }
    return survey.distributedOn;
  }

  public getLastSentOnState(survey) {
    var isSent = survey.isSent;
    return isSent;
  }

  public getSurveyDetails(survey) {
    try {
      if(survey==null) return "";
      var output = '<b>' + survey.title + '</b> <br><small>' + survey.distributedSurveyId + '<br>' + survey.surveyTitle + '</small>';
      return output;
    }
    catch(ex) {
      return "";
    }
  }

  public getManagerDetails(survey) { 
    try {
      if(survey.manager == null) {
        return "All Managers";
      }
      var output = survey.manager.firstname + " " + survey.manager.lastname + "<br><small>" + survey.manager.email + "<br>" + survey.manager.organization.name + "</small>";
      return output;
    }
    catch(ex) {
      return "";
    }
  }


  public loadOrganizations() {
    this.busy = this.lsApi.getOrganizationsForSelect().subscribe(resp => {
        if(resp.status) {
            this.organisations = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  public viewDetails(survey) {
    this.selectedQueueSurveys = survey;
    //$("#tipEmailDetails").modal('show');
  }


  public loadOrganizationManagers() {
    this.busy = this.lsApi.getOrganizationManagersForSelect(this.selectedOrganizationId, -1).subscribe(resp => {
        if(resp.status) {
            this.managers = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadOrganizations();
    this.loadQueuedSurveys();
  }

  public dontSendSurvey(id) {

    bootbox.confirm({message:"Do you want to remove this survey from queue?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.dontSendQueuedSurvey(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Survey Successfully Removed From Queue","Distribution Queue");
                this.loadQueuedSurveys();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }


  public queueSurvey(id) {

    bootbox.confirm({message:"Do you want to re-queue this survey?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.queueSurveyAgain(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Survey Successfully Re-queued","Distribution Queue");
                this.loadQueuedSurveys();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  public addSendSurvey(id) {

    bootbox.confirm({message:"Do you want to add this survey to queue?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.addSendQueuedSurvey(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Survey Successfully Added To Queue","Distribution Queue");
                this.loadQueuedSurveys();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  public manuallySendSurvey(id) {

    bootbox.confirm({message:"Do you want to send this survey manually?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.manuallySendQueuedSurvey(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Survey Successfully Distributed","Survey Distribution");
                this.loadQueuedSurveys();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/survey-distribution-queue/survey-distribution-queue.component.ts